import { FilterConfig } from "./utils";
import { compressToEncodedURIComponent, decompressFromEncodedURIComponent } from 'lz-string';

// Encode the filters as NDJSON. Also, trying to remove some implicit fields

export function encode(filter: FilterConfig[]) {
    const e = compressToEncodedURIComponent(filterToString(filter))
    return e
}

function filterToString(filters: FilterConfig[]) {
  return filters
    .map(filter => {
      let f = { ...filter }
      if (filter.isActive) {
        // delete is activeo
        f = { ...f, isActive: undefined }
      }
      return JSON.stringify(f)
    })
    .join('\n')
}

function stringToFilter(filter: string) {
  const filters = filter.split('\n').map(f => {
    const filter = JSON.parse(f)
    if (filter.isActive === undefined) {
      // delete is activeo
      filter['isActive'] = true
    }
    return filter
  })
  return filters
}

export function decode(filter?: string): FilterConfig[] {
    if (!filter) {
        return []
    }
    const filters = stringToFilter(decompressFromEncodedURIComponent(filter))
    return filters
}

export function decodeActiveOnly(param?: string) {
    if (!param) {
        return true
    }
    else return param === 'true'
}

export function encodeActiveOnly(activeOnly: boolean) {
    return activeOnly ? null : 'false'
}